import { useState } from 'react';

import { removeAll, showToast } from '@moniebook-web/utils';
import { useNavigate } from 'react-router';

import { endGhostSession } from '../api/end-ghost-session';
import { GHOST_SESSION_PAGES } from '../constants';
import { useSessionTokenPayload } from '../context/session-token-payload-context';

export const useEndGhostSession = () => {
    const navigate = useNavigate();
    const { sessionId } = useSessionTokenPayload();
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isEndingSession, setIsEndingSession] = useState(false);

    const openConfirmModal = () => setIsConfirmModalOpen(true);
    const closeConfirmModal = () => setIsConfirmModalOpen(false);

    const confirmEndSession = async () => {
        if (!sessionId) {
            return;
        }

        setIsEndingSession(true);

        try {
            await endGhostSession(sessionId);
            removeAll();
            navigate(GHOST_SESSION_PAGES.ENDED, { replace: true });
        } catch {
            showToast('error', 'Failed to end session');
            setIsEndingSession(false);
        }
    };

    return {
        isConfirmModalOpen,
        isEndingSession,
        openConfirmModal,
        closeConfirmModal,
        confirmEndSession,
    };
};
